export default __webpack_public_path__ + "static/media/online_test.d3d292d1.svg";